"use strict";

var _classCallCheck = require("/Users/ericgit/Dev/Projects/personal/portfolio/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ericgit/Dev/Projects/personal/portfolio/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connector = void 0;

var Utils_1 = require("../../../../Utils");

var Modes_1 = require("../../../../Enums/Modes");

var Connector = /*#__PURE__*/function () {
  function Connector(container) {
    _classCallCheck(this, Connector);

    this.container = container;
  }

  _createClass(Connector, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.options.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.Utils.isInArray(Modes_1.HoverMode.connect, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var container = this.container;
      var options = container.options;

      if (options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove") {
        var mousePos = container.interactivity.mouse.position;

        if (!mousePos) {
          return;
        }

        var distance = Math.abs(container.retina.connectModeRadius);
        var query = container.particles.quadTree.query(new Utils_1.Circle(mousePos.x, mousePos.y, distance));
        var i = 0;

        var _iterator = _createForOfIteratorHelper(query),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var p1 = _step.value;
            var pos1 = p1.getPosition();

            var _iterator2 = _createForOfIteratorHelper(query.slice(i + 1)),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var p2 = _step2.value;
                var pos2 = p2.getPosition();
                var distMax = Math.abs(container.retina.connectModeDistance);
                var xDiff = Math.abs(pos1.x - pos2.x);
                var yDiff = Math.abs(pos1.y - pos2.y);

                if (xDiff < distMax && yDiff < distMax) {
                  container.canvas.drawConnectLine(p1, p2);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            ++i;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return Connector;
}();

exports.Connector = Connector;